/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WbsRamoDTO } from './WbsRamoDTO';
import {
    WbsRamoDTOFromJSON,
    WbsRamoDTOFromJSONTyped,
    WbsRamoDTOToJSON,
    WbsRamoDTOToJSONTyped,
} from './WbsRamoDTO';

/**
 * 
 * @export
 * @interface WbsTestataDTO
 */
export interface WbsTestataDTO {
    /**
     * 
     * @type {number}
     * @memberof WbsTestataDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WbsTestataDTO
     */
    nome?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WbsTestataDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {Array<WbsRamoDTO>}
     * @memberof WbsTestataDTO
     */
    rami?: Array<WbsRamoDTO> | null;
}

/**
 * Check if a given object implements the WbsTestataDTO interface.
 */
export function instanceOfWbsTestataDTO(value: object): value is WbsTestataDTO {
    return true;
}

export function WbsTestataDTOFromJSON(json: any): WbsTestataDTO {
    return WbsTestataDTOFromJSONTyped(json, false);
}

export function WbsTestataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WbsTestataDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'rami': json['rami'] == null ? undefined : ((json['rami'] as Array<any>).map(WbsRamoDTOFromJSON)),
    };
}

export function WbsTestataDTOToJSON(json: any): WbsTestataDTO {
    return WbsTestataDTOToJSONTyped(json, false);
}

export function WbsTestataDTOToJSONTyped(value?: WbsTestataDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'nome': value['nome'],
        'descrizione': value['descrizione'],
        'rami': value['rami'] == null ? undefined : ((value['rami'] as Array<any>).map(WbsRamoDTOToJSON)),
    };
}

